import { Mapper } from 'src/base/mapper'
import { PlanTypeEntity } from 'src/data/entities/plan.entity'
import { PlanTypeModel } from 'src/domain/models/plan.model'
import { ProductTypeModel } from 'src/domain/models/product.model'

export class PlanAddonMapper extends Mapper<PlanTypeEntity, PlanTypeModel> {
	mapFrom(param: PlanTypeEntity): PlanTypeModel {
		return {
			planId: param.planId,
			planName: param.planName,
			planCode: param.planCode,
			planDescription: param.planDescription,
			isActive: param.isActive,
			pricingScheme: param.pricingScheme,
			freeTrial: param.freeTrial,
			startQty: param.startQty,
			endQty: param.endQty,
			productId: param.productId,
			productName: param.productName,
			planType: param.planType,
			price: param.price,
			unitId: param.unitId,
			billEvery: param.billEvery,
			billingCycle: param.billingCycle,
			billingInterval: param.billingInterval,
			addonType: param.addonType,
			associatePlans: param.associatePlans,
			isDelete: param.isDelete,
			planDescriptionEN: param.planDescriptionEN,
			planGroup: param.planGroup,
			planItems: param.planItems,
			planNameEN: param.planNameEN,
			planPicture: param.planPicture,
			planPriceVolumes: param.planPriceVolumes,
			planShortDescription: param.planShortDescription,
			planShortDescriptionEN: param.planShortDescriptionEN,
			isPostPay: param.isPostPay,
			isFree: param.isFree,
			itemNumber: param.itemNumber,
			refPlanCode: param.refPlanCode,
			associatePlanList: param.associatePlanList,
			keyDescription: param.keyDescription,
			product: param.product as ProductTypeModel,
			type: param.type,
			pricePerSeat: null,
		}
	}

	mapTo(param: PlanTypeModel): PlanTypeEntity {
		return {
			planId: param.planId,
			planName: param.planName,
			planCode: param.planCode,
			planDescription: param.planDescription,
			isActive: param.isActive,
			pricingScheme: param.pricingScheme,
			freeTrial: param.freeTrial,
			startQty: param.startQty,
			endQty: param.endQty,
			productId: param.productId,
			productName: param.productName,
			planType: param.planType,
			price: param.price,
			unitId: param.unitId,
			billEvery: param.billEvery,
			billingCycle: param.billingCycle,
			billingInterval: param.billingInterval,
			addonType: param.addonType,
			associatePlans: param.associatePlans,
			isDelete: param.isDelete,
			planDescriptionEN: param.planDescriptionEN,
			planGroup: param.planGroup,
			planItems: param.planItems,
			planNameEN: param.planNameEN,
			planPicture: param.planPicture,
			planPriceVolumes: param.planPriceVolumes,
			planShortDescription: param.planShortDescription,
			planShortDescriptionEN: param.planShortDescriptionEN,
			isPostPay: param.isPostPay,
			isFree: param.isFree,
			itemNumber: param.itemNumber,
			refPlanCode: param.refPlanCode,
			associatePlanList: param.associatePlanList,
			keyDescription: param.keyDescription,
			product: param.product,
			type: param.type,
		}
	}
}
